import useSWR from 'swr';

import container from 'src/container';
import { EventResponseStatus, MunduEvent } from 'src/domain/event';
import { getOriginalOccurrenceStart } from './eventFormModel';

const {
    cradle: { munduClient },
} = container;

/** Share one occurrence's roster between the tab preview and response panel. */
export const useEventResponseStatus = (event: MunduEvent, enabled = true) => {
    const occurrenceStart = getOriginalOccurrenceStart(event);
    return useSWR<EventResponseStatus>(
        enabled && event.canViewResponseStatus
            ? ['eventResponseStatus', event.id, occurrenceStart]
            : null,
        () => munduClient.getEventResponseStatus(event.id, occurrenceStart),
        { dedupingInterval: 0 },
    );
};
